<template>
  <sfs-form-modal
    :id="modalId"
    :title="terminology.verificationActionButton"
    @on-hide="resetFormData"
  >
    <compliance-document-verifications-form
      @on-submit="create"
      @on-save="onSave"
      @on-cancel="closeModal"
      :key="formKey"
      :audited_at="currentTime"
      :document-type="documentType"
    />
  </sfs-form-modal>
</template>

<script>
import ComplianceDocumentVerificationsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';
import { DateTime } from 'luxon';
import complianceDocumentTerminology from '@/utils/complianceDocumentTerminology';

export default {
  name: 'ComplianceDocumentVerifcationsAddModal',
  mixins: [formModalMixin],
  components: {
    ComplianceDocumentVerificationsForm,
  },
  props: {
    complianceDocumentCoverageId: { type: Number, required: true },
    documentType: String,
  },
  data() {
    return {
      currentTime: DateTime.now().toString(),
      modalId: 'compliance-document-verification-add-modal',
    };
  },
  computed: {
    terminology() {
      return complianceDocumentTerminology(this.documentType);
    },
  },
  methods: {
    create(data, handleCreate) {
      handleCreate(this.$complianceDocumentVerificationsAPI.create(this.complianceDocumentCoverageId, data));
    },
    onSave() {
      this.closeModal();
      this.resetFormData();
      this.$emit('on-save');
    },
  },
};
</script>
